import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

import {useUrlParam} from '../../../shared/hooks/useUrlParam'

export const QueryKey = 'structure'

type UpmEntityType = 'Plant' | 'Area' | 'ProductionLine' | 'Department' | 'Equipment'

export interface StructureNode {
  id: string
  name: string
  signalCount: number
  entityType: UpmEntityType
  children: StructureNode[] | null
  upmId: string
  entityLabel: string
}

export const useGetPlantStructure = () => {
  const plantId = useUrlParam('plantId')

  return useQuery({
    queryKey: [QueryKey, plantId],
    queryFn: async () => {
      const path = `upm/structure/plant/${plantId}?includeEquipment=false`
      return (await ApiClient.axiosInstance.get<StructureNode>(path)).data
    },
    staleTime: Infinity
  })
}
